/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import {
  apiUrls,
  checkEvenOddInArray,
  manageCounterProcessing,
  metamaskErrorMessages,
  notificationPosition,
  notificationSetting,
  notificationType,
  notUndefined,
  sendPostRequest,
  showNotification,
} from "../Common";
import { loaderType, StartLoader, StopLoader } from "../Common/Loader";
import {
  changePublicSaleStatus,
  connectWallet,
  getBalanceOf,
  getcurrentlyConnectChain,
  getcurrentlyConnectWallet,
  getWalletOfOwner,
  isWhitelisted,
  publicSaleStatus,
  totalValues,
} from "../Scripts/interact";
import { MintButton } from "../SubSection/MintButton";

const Registration = () => {
  const [waiting, setWaiting] = useState(false);
  const [message, setMessage] = useState("");
  const [publicSale, setPublicSale] = useState(false);
  const [wallet, setWallet] = useState({
    address: null,
    balance: null,
    chainId: null,
  });
  const [walletConnected, setWalletConnected] = useState(false);
  const [quantity, setQuantity] = useState(1);
  const [totalAmount, setTotalAmount] = useState(0);
  const [maxValues, setMaxValues] = useState({
    maxMints: 0,
    totalRemaining: 0,
    maxPerMint: 0,
    price: null,
  });
  const [envValues, setEnvValues] = useState({
    ethValue: 0,
    perMint: 0,
  });
  const quantityRef = useRef();

  useEffect(() => {
    const processFetchAPIData = async () => {
      // const addresses = [
      //   "0xdD870fA1b7C4700F2BD7f44238821C26f7392148",
      //   "0x583031D1113aD414F02576BD6afaBfb302140225",
      //   "0x4B0897b0513fdC7C541B6d9D7E929C4e5364D2dB",
      //   "0x14723A09ACff6D2A60DcdF7aA4AFf308FDDC160C",
      //   "0xCA35b7d915458EF540aDe6068dFe2F44E8fa733c",
      //   "0x54Ee9d0Ef39518ed43571dB034C10799D137cD26",
      //   "0x0A098Eda01Ce92ff4A4CCb7A4fFFb5A43EBC70DC",
      //   "0x78731D3Ca6b7E34aC0F824c42a7cC18A495cabaB",
      // ];
      // sendPostRequest("/api/rootHash", {
      //   addresses,
      // }).then((response) => {
      //   StopLoader(loaderType.BUTTON);
      //   console.log(response);
      // });

      // sendPostRequest("/api/addressHash", {
      //   addresses,
      //   wallet_address: "0x54Ee9d0Ef39518ed43571dB034C10799D137cD26",
      // }).then((response) => {
      //   StopLoader(loaderType.BUTTON);
      //   if (response?.status) {
      //     console.log(response);
      //   } else {
      //     showNotification(notificationType.DANGER, response.message, {
      //       title: "Error",
      //       duration: 6000,
      //       notificationPosition: notificationPosition.BOTTOM_RIGHT,
      //     });
      //   }
      // });

      const { status, message, address, walletBalance, chainId } =
        await getcurrentlyConnectWallet();

      const response = await publicSaleStatus();
      if (response?.status) {
        setPublicSale(response?.publicSale);
      } else {
        showNotification(
          notificationType.DANGER,
          response.message,
          notificationSetting
        );
      }

      if (status) {
        setWalletConnected(true);
      } else {
        setWalletConnected(false);
        setMaxValues({
          maxMints: 0,
          totalRemaining: 0,
          maxPerMint: 0,
          price: null,
        });
      }

      setEnvValues({
        ethValue: process.env.REACT_APP_ETHERS_VALUE,
        perMint: process.env.REACT_APP_MAX_PER_MINT,
      });
      setWallet(() => {
        return { address: address, balance: walletBalance, chainId: chainId };
      });
      setMessage(message);
      setTotalAmountValues(quantity);

      monitorWalletChange();
      await getcurrentlyConnectChain();
    };
    processFetchAPIData().catch(console.error);
  }, [wallet.address]);

  useEffect(() => {
    if (maxValues.price !== null) {
      setTotalAmountValues(quantity);
    }
  }, [maxValues]);

  // useEffect(() => {
  //   const getAndSetTotalValues = async () => {
  //     if (walletConnected) {
  //       try {
  //         setWaiting(true);
  //         let response = await totalValues();
  //         if (response?.total && Object.keys(response?.total).length > 0) {
  //           setWaiting(false);
  //         }
  //         setTotalValues(response?.total);
  //       } catch (error) {
  //         console.log(error);
  //         showNotification(
  //           notificationType.DANGER,
  //           metamaskErrorMessages.browserNotSupported,
  //           notificationSetting
  //         );
  //         setMaxValues({
  //           maxMints: 100,
  //           totalRemaining: 0,
  //           maxPerMint: 3,
  //           price: null,
  //         });
  //       }
  //     }
  //   };
  //   getAndSetTotalValues().catch(console.error);
  // }, [walletConnected]);

  const setTotalAmountValues = (quantity) => {
    // let price;
    // if (mintSaleType) {
    //   price = 0;
    // }
    setTotalAmount(
      (parseFloat(quantity) * parseFloat(envValues.ethValue)).toFixed(2)
    );
  };

  const monitorWalletChange = async () => {
    const { ethereum } = window;
    if (ethereum) {
      try {
        const connectAddresses = await ethereum.on(
          "accountsChanged",
          (accounts) => {
            if (accounts.length > 0) {
              setMessage(`Current Wallet is ${accounts[0]}`);
              setWallet(() => {
                return { address: accounts[0], balance: null, chainId: null };
              });
            } else {
              setMessage(
                "Connect to MetaMask by Clicking 'Connect to Wallet' Button"
              );
              setWallet({});
            }
          }
        );
        // console.log("Selected Address: ", connectAddresses?.selectedAddress);
      } catch (error) {
        return {
          status: false,
          address: "",
          message: error.message,
        };
      }
    } else {
      return {
        status: false,
        address: "",
        message: (
          <span>
            <p>
              {" "}
              🦊{" "}
              <a
                target="_blank"
                rel="noreferrer"
                href={`https://metamask.io/download.html`}
              >
                You must install Metamask, a virtual Ethereum wallet, in your
                browser.
              </a>
            </p>
          </span>
        ),
      };
    }
  };

  const connectWalletPressed = async () => {
    const response = await connectWallet();

    if (response.status) {
      setWalletConnected(true);
    } else {
      setWalletConnected(false);
      showNotification(
        notificationType.DANGER,
        response.message,
        notificationSetting
      );
    }
    setMessage(response.message);
    setWallet({
      address: response.address,
      balance: response.walletBalance,
      chainId: response.chainId,
    });
  };

  const getWalletofOwnerDetails = async () => {
    const response = await getWalletOfOwner(wallet?.address);
    if (response?.status) {
      if (notUndefined(response?.wallet) && response?.wallet.length > 0) {
        console.log("Wallet of Owner is: ", response?.wallet);
        console.log("Even Odd Details:", checkEvenOddInArray(response?.wallet));
        let details = checkEvenOddInArray(response?.wallet);
        if (details.evenCount > 0 && details.oddCount > 0) {
          console.log("Congratulations! You are Able to Mint a Baby NFT");
        }
      }
    } else {
      showNotification(
        notificationType.DANGER,
        response.message,
        notificationSetting
      );
    }
  };

  const getDetailsofBalance = async () => {
    const response = await getBalanceOf(wallet?.address);
    if (response?.balance) {
      console.log(`Balance is: ${response?.balance}ETH`);
    } else {
      showNotification(
        notificationType.DANGER,
        response.message,
        notificationSetting
      );
    }
  };

  const getIsWhitelistedDetails = async () => {
    const response = await isWhitelisted(wallet.address);
    if (response?.status) {
      console.log("Is Whitelisted: ", response?.whitelisted);
      showNotification(
        response?.whitelisted
          ? notificationType.SUCCESS
          : notificationType.DANGER,
        `${
          response?.whitelisted
            ? "Yes, Your Address is "
            : "No, Your Address is not "
        }Whitelisted`,
        notificationSetting
      );
    } else {
      showNotification(
        notificationType.DANGER,
        response.message,
        notificationSetting
      );
    }
  };

  const togglePubliSaleStatus = async () => {
    const response = await changePublicSaleStatus(!publicSale);
    console.log("Change Status: ", response);
    if (response.status) {
      console.log("Change Status: ", response?.publicSaleStarted);
    } else {
      showNotification(
        notificationType.DANGER,
        "Only Owner can Change the Public Sale Status",
        notificationSetting
      );
    }
  };

  const setTotalValues = (response) => {
    if (response !== undefined) {
      setMaxValues(response);
    } else {
      showNotification(
        notificationType.DANGER,
        metamaskErrorMessages.browserNotSupported,
        notificationSetting
      );
      setMaxValues({
        maxMints: 100,
        totalRemaining: 0,
        maxPerMint: 3,
        price: null,
      });
    }
  };

  const manageCounter = (buttonType) => {
    const { min, max, value } = quantityRef.current;
    let newValue = manageCounterProcessing(buttonType, min, value, max);
    setQuantity(newValue);
    setTotalAmountValues(newValue);
  };

  const checkUserInDB = (wallet_id) => {
    StartLoader(loaderType.BUTTON);
    sendPostRequest(apiUrls.checkUser, {
      wallet_id: wallet.address,
    }).then((response) => {
      StopLoader(loaderType.BUTTON);
      if (response?.status === false) {
        showNotification(
          notificationType.DANGER,
          // response.message,
          metamaskErrorMessages.addressNotWhitelisted,
          {
            title: "Error",
            duration: 6000,
            notificationPosition: notificationPosition.BOTTOM_RIGHT,
          }
        );
      } else if (response?.status === true) {
        registerAddress();
        // showNotification(
        //   notificationType.SUCCESS,
        //   "You are now successfully registered with Supercreators. You can mint your desired NFT soon.",
        //   {
        //     title: "Address Registered",
        //     duration: 6000,
        //     notificationPosition: notificationPosition.BOTTOM_RIGHT,
        //   }
        // );
      }
    });
  };

  // const mintNFTPressed = async (event) => {
  //   event.preventDefault();
  //   StartLoader(loaderType.BUTTON);
  //   const { status, message, hash } = await mintNFT(quantity,totalAmount);
  //   if (status) {
  //     StopLoader(loaderType.BUTTON);
  //     let response = await totalValues();
  //     setTotalValues(response?.total);
  //     setQuantity(1);
  //     setTotalAmount(
  //       (
  //         parseFloat(1) * parseFloat(maxValues.price)
  //       ).toFixed(2)
  //     );
  //     showNotification(notificationType.SUCCESS, message, {
  //       title: "Minting Successful",
  //       duration: 6000,
  //       notificationPosition: notificationPosition.BOTTOM_RIGHT,
  //     });
  //   } else {
  //     StopLoader(loaderType.BUTTON);
  //     showNotification(notificationType.DANGER, message, {
  //       title: "",
  //       duration: 5000,
  //       notificationPosition: notificationPosition.BOTTOM_RIGHT,
  //     });
  //   }
  // };

  const registerAddress = () => {
    sendPostRequest(apiUrls.signUp, {
      wallet_id: wallet.address,
      number_token: quantity,
    }).then((response) => {
      if (response?.status === false) {
        showNotification(notificationType.DANGER, response.message, {
          title: "Error",
          duration: 6000,
          notificationPosition: notificationPosition.BOTTOM_RIGHT,
        });
      } else if (response?.status === true) {
        showNotification(
          notificationType.SUCCESS,
          "You are now successfully registered with Supercreators. You can mint your desired NFT soon.",
          {
            title: "Address Registered",
            duration: 6000,
            notificationPosition: notificationPosition.BOTTOM_RIGHT,
          }
        );
        setQuantity(1);
        setTotalAmountValues(1);
      }
    });
  };

  const registerPressed = (event) => {
    console.log("Wallet: ", wallet);
    if (
      parseFloat(totalAmount).toFixed(3) > parseFloat(wallet.balance).toFixed(3)
    ) {
      showNotification(
        notificationType.DANGER,
        metamaskErrorMessages.insufficientFund,
        {
          title: "Insufficent fund:",
          duration: 6000,
          notificationPosition: notificationPosition.BOTTOM_RIGHT,
        }
      );
    } else {
      checkUserInDB();
    }
  };

  return (
    <div className="banner-sec mint-ban">
      <div className="container">
        <h2 className="text-center">
          Super Creators Assemble{" "}
          <span className="tknreg">Token registration</span>
        </h2>
        <div className="banner-item">
          <div className="item-left">
            <div className="img-art">
              <img src="assets/images/creator-1.png" alt="" />
            </div>
          </div>
          <div className="item-right text-start">
            {/* <div className="title1">Max tokens: {maxValues.maxPerMint}</div> */}
            <p className="p1">
              Please select the number of tokens you intend to mint
            </p>
            <small>
              Note: The number of tokens you click to register does not
              correspond to the number you may actually be able to mint.
              <br /> The purpose of this page is to give us an indication of how
              many tokens our whitelisted users intend to mint. To know <br />
              how many tokens your wallet has been allocated, please find these
              details on our discord server in the announcements section.
            </small>
            <form className="min-form">
              <div className="counter-row">
                <div className="inner-item">
                  <div className="input-counter mb-3">
                    <button
                      type="button"
                      className="minus-btn"
                      id="minus-btn"
                      onClick={() => manageCounter("minus")}
                    >
                      <i className="bi bi-dash"></i>
                    </button>
                    <span>Qty.</span>
                    <input
                      type="text"
                      id="quantity"
                      name="quantity"
                      className="form-control"
                      value={quantity}
                      ref={quantityRef}
                      min={1}
                      max={envValues.perMint}
                      onChange={() => console.log("")}
                    />
                    <button
                      type="button"
                      className="plus-btn"
                      id="plus-btn"
                      onClick={() => manageCounter("plus")}
                    >
                      <i className="bi bi-plus"></i>
                    </button>
                  </div>
                  <div className="input-form mb-3">
                    <span>Price(ETH)</span>
                    <input
                      type="text"
                      className="form-control"
                      value={totalAmount}
                      readOnly
                    />
                  </div>
                </div>
                {walletConnected && waiting ? (
                  <button
                    className={"btn btn-dark mt-3"}
                    type={"button"}
                    disabled
                  >
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    {"Fetching Data! Please Wait..."}
                  </button>
                ) : walletConnected ? (
                  <MintButton
                    type={"button"}
                    className={"btn btn-dark mt-3 wallet-connect"}
                    onClick={registerPressed}
                  >
                    Register
                  </MintButton>
                ) : (
                  <button
                    type="button"
                    className="btn btn-dark mt-3 wallet-connect"
                    onClick={connectWalletPressed}
                  >
                    Connect to Wallet
                  </button>
                )}
                {/* <MintButton
                  type={"button"}
                  className={"btn btn-dark mt-3"}
                  onClick={mintNFTPressed}
                >
                  Mint!
                </MintButton> */}
              </div>
            </form>
            <p className="p2">
              You must register for your tokens via this page to be able to mint
              before the public minting day
            </p>
          </div>
        </div>
        <div className="termETH">
          *No ETH will be taken from your wallet when you click 'Register',
          however, you must have enough ETH in your wallet to register for your
          tokens
        </div>
        {/* <div>
          <button className={"btn"} onClick={getWalletofOwnerDetails}>
            Wallet of Owner Details
          </button>
          <button className={"btn"} onClick={getDetailsofBalance}>
            Balance Of Details
          </button>
          <button className={"btn"} onClick={getIsWhitelistedDetails}>
            Check, Are You Whitelisted?
          </button>
          <button className={"btn"} onClick={togglePubliSaleStatus}>
            Toggle Public Sale Status
          </button>
        </div> */}
      </div>
    </div>
  );
};

export default Registration;
